const API_BASE_URL = 'https://catalina.xseu.net/3393';

const USER_ID_KEY = 'megahit_user_id';

export function getUserId() {
  let userId = localStorage.getItem(USER_ID_KEY);
  if (!userId) {
    userId = 'web_' + crypto.randomUUID();
    localStorage.setItem(USER_ID_KEY, userId);
  }
  return userId;
}

export async function registerUser() {
  const userId = getUserId();
  try {
    const response = await fetch(`${API_BASE_URL}/api/user/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId }),
    });
    const data = await response.json();
    return data.success;
  } catch (error) {
    console.error('Error registering user:', error);
    return false;
  }
}

export async function checkIsFavorite(songTitle, songArtist) {
  const userId = getUserId();
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/favorites/check?userId=${encodeURIComponent(userId)}&songTitle=${encodeURIComponent(songTitle)}&songArtist=${encodeURIComponent(songArtist)}`
    );
    const data = await response.json();
    return data.isFavorite || false;
  } catch (error) {
    console.error('Error checking favorite:', error);
    return false;
  }
}

export async function addFavorite(songTitle, songArtist, songArtwork) {
  const userId = getUserId();
  try {
    const response = await fetch(`${API_BASE_URL}/api/favorites/add`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, songTitle, songArtist, songArtwork }),
    });
    const data = await response.json();
    return data.success;
  } catch (error) {
    console.error('Error adding favorite:', error);
    return false;
  }
}

export async function removeFavorite(songTitle, songArtist) {
  const userId = getUserId();
  try {
    const response = await fetch(`${API_BASE_URL}/api/favorites/remove`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, songTitle, songArtist }),
    });
    const data = await response.json();
    return data.success;
  } catch (error) {
    console.error('Error removing favorite:', error);
    return false;
  }
}

export async function toggleFavorite(songTitle, songArtist, songArtwork, currentIsFavorite) {
  if (currentIsFavorite) {
    return await removeFavorite(songTitle, songArtist);
  } else {
    return await addFavorite(songTitle, songArtist, songArtwork);
  }
}
